import { render, staticRenderFns } from "./PaidServices.vue?vue&type=template&id=34dae117"
import script from "./PaidServices.vue?vue&type=script&lang=js"
export * from "./PaidServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports